import { Component, OnInit } from '@angular/core';
import {
  CampusUnitsCommunicationsDataService,
  CampusUnitsFaqSection,
  CampusUnitsFaq,
  ConfirmDialog,
  SortService,
  NavigationService
} from '../../shared';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NewQuestionDialogComponent } from './new-question-dialog/new-question-dialog.component';
import { NewSectionDialogComponent } from './new-section-dialog/new-section-dialog.component';

@Component({
  templateUrl: './campus-units-communications.component.html',
  styleUrls: ['./campus-units-communications.component.scss']
})
export class CampusUnitsCommunicationsComponent implements OnInit {
  navigationService: NavigationService = null;
  newSection: CampusUnitsFaqSection;
  newQuestion: CampusUnitsFaq;
  sections: CampusUnitsFaqSection[] = [];
  editMode: boolean;
  loadingSections = true;
  emptySections: boolean;

  constructor(
    private communicationsService: CampusUnitsCommunicationsDataService,
    private dialog: MatDialog,
    private sorter: SortService,
    navigationService: NavigationService
  ) {
    this.navigationService = navigationService;
  }

  ngOnInit() {
    this.editMode = false;
    this.emptySections = true;
    this.newSection = new CampusUnitsFaqSection();
    this.getSections();
  }

  openQuestionDialog(
    sectionSelected: CampusUnitsFaqSection,
    question: CampusUnitsFaq,
    isNew: boolean
  ) {
    this.dialog
      .open(NewQuestionDialogComponent, {
        data: { section: sectionSelected, question: question, isNew: isNew }
      })
      .afterClosed()
      .subscribe(() => {
        this.getSections();
      });
  }

  getSections() {
    this.communicationsService.getSections().subscribe(sectionsData => {
      if (sectionsData.length > 0) {
        this.emptySections = false;
      } else {
        this.emptySections = true;
      }
      // sort sections by title for display
      sectionsData.sort(this.sorter.sortFaqSections);
      this.sections = sectionsData;
      this.loadingSections = false;
    });
  }

  getSafeContent(answer: string) {
    return answer;
  }

  editSection() {
    this.dialog
      .open(NewSectionDialogComponent, { maxHeight: '40vw', data: { sections: this.sections } })
      .afterClosed()
      .subscribe(() => {
        this.getSections();
      });
  }

  deleteDialog(question: CampusUnitsFaq) {
    const message = 'Are you sure you want to delete the question?';
    const confirmDialog = this.openConfirmDialog(message);

    confirmDialog.afterClosed().subscribe(response => {
      if (response) {
        this.deleteQuestion(question.campusUnitsFaqId);
      }
    });
  }

  deleteQuestion(questionId: number) {
    this.communicationsService.deleteQuestion(questionId).subscribe(q => {
      this.getSections();
    });
  }

  private openConfirmDialog(message: string): MatDialogRef<ConfirmDialog, any> {
    return this.dialog.open(ConfirmDialog, {
      autoFocus: false,
      data: { title: 'Please confirm', message: message }
    });
  }
}
